import {
  CheckboxField,
  Form,
  SubmitButton,
  TextInputField,
} from '@/components';
import { HierarchyLabelFormSchema } from '@/features/tenant-manager/models';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type FormValues = z.infer<typeof HierarchyLabelFormSchema>;

type Props = {
  initialValues?: Partial<FormValues>;
  onSubmit: (values: FormValues) => void;
};

export const HierarchyLabelForm: FC<Props> = ({ initialValues, onSubmit }) => {
  const { t } = useTranslation();
  const defaultValues = {
    isUsedForCommentOrWorkflow: true,
    ...initialValues,
  };
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    defaultValues,
    resolver: zodResolver(HierarchyLabelFormSchema),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <TextInputField
        name="name"
        autocompleteKey="hierarchyLabel.name"
        label={t('name')}
        control={control}
        errors={errors}
        required
      />

      <CheckboxField
        name="isUsedForCommentOrWorkflow"
        label={t('hierarchy-labels.enabled-label')}
        text={t('hierarchy-labels.enabled')}
        control={control}
        errors={errors}
      />

      <SubmitButton loading={isSubmitting} disabled={!isDirty} />
    </Form>
  );
};
